import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Breadcrumb, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

const Breadcrumbs = ({ crumbs }) => {
  const dynamicTitles = useSelector(
    (state) => state.ui?.breadcrumbOverrides || {}
  );
  const history = useHistory();

  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <div
      style={{
        fontSize: '16px',
        paddingBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Breadcrumb>
        {crumbs.map(({ name, path, Component }, index) => {
          const isLast = index === crumbs.length - 1;
          const isDynamic = !!dynamicTitles[path];
          const displayTitle = dynamicTitles[path] || name;

          const customStyle = {};
          if (isLast || isDynamic) customStyle.fontWeight = 'bold';
          if (isDynamic) customStyle.color = 'var(--ant-primary-color)';

          return (
            <Breadcrumb.Item key={path}>
              {isLast ? (
                <span style={customStyle}>{displayTitle}</span>
              ) : Component ? (
                <Link to={path} style={customStyle}>
                  {displayTitle}
                </Link>
              ) : (
                <span style={customStyle}>{displayTitle}</span>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <Button
        size="small"
        icon={<ArrowLeftOutlined />}
        onClick={() => history.goBack()}
      >
        Volver
      </Button>
    </div>
  );
};

export default Breadcrumbs;
